import React from 'react'
import { ListDropdownType } from '../../../types/types'
import { Autocomplete, Popover, TextField } from '@mui/material';

function ListDropdown(props : ListDropdownType) {
    const [value, setValue] = React.useState<string | null>(null);

    const handleClose = () => {
        props.setAnchorEl(null);
    };
  return (
    <Popover 
    id={props.id}
    open={props.open}
    anchorEl={props.anchorEl}
    onClose={handleClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: "left",
      }}
    >
    <div style={{height: '40vh', padding: '8%', width: '25vw'}}>
        <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={props.listData || []}
        onChange={(event, newValue) => {
            if (newValue != null) {
                props.onSelect(newValue);
                handleClose();
            }
        }}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Select Code" />}
        />
    </div>
    </Popover>
  )
}

export default ListDropdown